import React from 'react';
import PropTypes from 'prop-types';

class Notification extends React.Component {
    static propTypes = {
        displayText: PropTypes.string.isRequired,
        show: PropTypes.bool
    };

    render() {
        const { displayText, show } = this.props;

        return (
            <span style={{ opacity: show ? 1 : 0, fontSize: '12px', marginTop: '5px' }} className={'notification'}>
                {displayText}
            </span>
        );
    }
}

export default Notification;
